var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtrl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.121 15.828q-.517.268-1.079.405-.562.137-1.172.137-1.821 0-2.886-1.016-1.064-1.02-1.064-2.764 0-1.748 1.064-2.763 1.065-1.02 2.886-1.02.61 0 1.172.136.562.137 1.08.405v1.509q-.523-.356-1.031-.522-.508-.167-1.07-.167-1.005 0-1.582.645-.576.645-.576 1.777 0 1.128.576 1.773.577.644 1.582.644.562 0 1.07-.166t1.03-.522v1.509zm3.394-6.621v1.552h1.801v1.25h-1.801v2.32q0 .38.151.517.151.132.6.132h.899v1.25h-1.499q-1.035 0-1.47-.43-.43-.434-.43-1.47V12.01h-.869v-1.25h.87V9.207h1.748zm6.938 3.041q-.23-.107-.459-.156-.224-.054-.454-.054-.674 0-1.04.435-.361.43-.361 1.235v2.52H15.39v-5.469h1.748v.898q.337-.537.771-.78.44-.25 1.05-.25.088 0 .19.01.103 0 .298.03l.005 1.581zm.879-3.618h1.748v7.598h-1.748V8.63z",
    fontWeight: 700,
    fontSize: 10,
    fontFamily: "DejaVu Sans",
    letterSpacing: 0,
    wordSpacing: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtrl);
export default __webpack_public_path__ + "static/media/ctrl.6e3304547119af462087aea802eecfdf.svg";
export { ForwardRef as ReactComponent };